<template>
  <v-row class="fill-height overview-container py-0">
    <v-col cols="12" :md="isMobile? 0 : 2" class="py-0">
      <KidDetailOverviewSideMenu />
    </v-col>
    <v-col cols="12" :md="isMobile? 12 : 10">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
  import KidMissionList from "@/components/Kids/KidMissionList";
  import KidProfile from "@/components/Kids/KidProfile";
  import KidGifts from "@/components/Kids/KidGifts";
  import KidDetailOverviewSideMenu from "@/components/Kids/KidDetailOverviewSideMenu";

  export default {
    name: "KidInfoTabs",
    components: {
      KidMissionList,
      KidProfile,
      KidGifts,
      KidDetailOverviewSideMenu,
    },
    data() {
      return {
        tabItems: [
          {
            index: 0,
            title: "Missions",
            icon: "",
            content: KidMissionList,
            route: "KidQuests",
          },
          {
            index: 1,
            title: "Profile",
            icon: "",
            content: KidProfile,
            route: "KidProfile",
          },
          {
            index: 2,
            title: "Gifts",
            icon: "",
            content: KidGifts,
            route: "KidGifts",
          },
        ],
      };
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
      activeTab: {
        get() {
          if (this.$route.name === "KidProfile") {
            return 1;
          }
          if (this.$route.name === "KidGifts") {
            return 2;
          }
          return 0;
        },
        set(newValue) {
          return newValue;
        },
      },
    },
    methods: {
      changeRoute(route) {
        if (!this.$validator.isEmpty(route)) {
          this.$router.push({ name: route, params: { id: this.$route.params.id } });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidInfoTabs.vue